import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { getSpecialities, next, getLanguages } from "../actions/index";
import MainImageHeader from "./styledComponents/mainImageHeader.component";
import MainWordContainer from "./styledComponents/mainWordContainer.component";
import MainListContainer from "./styledComponents/mainListContainer.component";
import { stateProps } from "../types";
import AlertBox from "./common/alertBox.component";

const Home: React.FC = () => {
  const dispatch = useDispatch();

  const { errorData } = useSelector(
    (state: { router: History; doctorInfo: stateProps }) => state.doctorInfo
  );

  useEffect(() => {
    dispatch(getLanguages());
    dispatch(getSpecialities());
  }, []);

  const navigateToForm = () => {
    dispatch(next());
  };

  return (
    <React.Fragment>
      <Container
        maxWidth="lg"
        sx={{
          maxWidth: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
          maxHeight: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
          paddingLeft: { xs: "0px" },
          paddingRight: { xs: "0px" },
        }}
      >
        {errorData.status && <AlertBox alertTitle={errorData.msg} />}
        <MainImageHeader />
        <Box
          sx={{
            display: { xs: "flex", md: "inline-flex" },
            width: "100%",
            paddingLeft: { md: "100px", xl: "250px" },
            paddingRight: { md: "100px", xl: "250px" },
            justifyContent: { sm: "space-around", md: "space-between" },
            flexDirection: { xs: "column", sm: "row" },
            marginTop: { xs: "10px", sm: "10px", md: "50px" },
          }}
        >
          <MainWordContainer
            title={"Welcome to oDoc!"}
            subTitleOne={"Ready to create your oDoc profile?"}
            subTitleTwo={" This will take about 7 minutes to complete."}
            onClick={navigateToForm}
          />
          <MainListContainer onClick={navigateToForm} percent={0} />
        </Box>
      </Container>
    </React.Fragment>
  );
};
export default Home;
